import { useTranslation } from "react-i18next";

import gridThemeCss from "@/landing/styles/grid-theme.css?url";
import { TextLink } from "@/landing/system/actions";
import { HeroCat } from "@/landing/system/cat";
import { PillLink } from "@/landing/system/controls";
import { Ground, SectionHeading } from "@/landing/system/layout";

// Also the router's default not-found page outside the landing, so it loads
// the Grid tokens itself and falls back when there is no landing header.
export function WondaNotFoundPage() {
  const { t } = useTranslation();
  return (
    <>
      <link rel="stylesheet" href={gridThemeCss} />
      <div className="grid-theme">
        <Ground lattice className="mt-[calc(var(--header-height,0px)*-1)]">
          <div className="grid min-h-dvh items-center gap-12 px-(--g-margin) pt-[calc(var(--header-height,0px)+clamp(56px,8vw,112px))] pb-[clamp(56px,7vw,104px)] lg:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]">
            <div>
              <SectionHeading
                as="h1"
                eyebrow="404"
                title={t("notFound.title")}
                sub={t("notFound.description")}
              />
              <div className="mt-[34px] flex flex-wrap items-center gap-x-6 gap-y-4">
                <PillLink to="/" variant="ink">
                  {t("notFound.backToHome")}
                </PillLink>
                <TextLink to="/docs">Docs</TextLink>
                <TextLink to="/blog">Blog</TextLink>
              </div>
            </div>
            <HeroCat />
          </div>
        </Ground>
      </div>
    </>
  );
}
